import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ListNavigationModule } from '../list-navigation/list-navigation.module';
import { RouteSelectorComponent } from './components/route-selector/route-selector.component';
import { RouteSelectorItemComponent } from './components/route-selector-item/route-selector-item.component';

@NgModule({
  imports: [CommonModule, SharedModule, ListNavigationModule],
  declarations: [RouteSelectorComponent, RouteSelectorItemComponent],
  exports: [RouteSelectorComponent],
})
export class RouteSelectorModule {}
